
export default {
  productData: {
    serialNumber: 'DA-HMS-002',
    name: 'Holzbalkendecke mit Schalldämmplatten l Aufbau 2',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: 'ohne',
          value: 'nw-0'
        },
        {
          type: 'soundInsulation',
          title: { de: 'Schalldämmplatte' },
          output: '2 x 15 mm',
          value: 'si-30'
        },
        {
          type: 'insulation',
          title: {
            de:
              'Holzfaserdämmplatte',
          },
          output: '≥ 40',
          value: 'w-40'
        },
        {
          type: 'fill',
          title: {
            de:
              'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 132 kg/m<sup>2</sup>), Rieselschutz',
          },
          output: '≥ 80',
          value: 'scsb-80'
        },
        {
          type: 'woodenPanel',
          title: { de: 'Holzwerkstoffplatte HW' },
          output: '≥ 22',
          value: 22
        },
        {
          type: 'supportingStructure',
          title: { de: 'Balken' },
          output: '240',
          value: 'b-240'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Hohlraumdämpfung' },
          output: '2 x 120',
          value: 'h-240'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Lattung' },
          output: '24',
          value: 'ba-24'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Gipsplatte GKFI' },
          output: '12,5',
          value: 'g-12.5'
        }
      ],
      sum: {
        output: '449',
        value: 449
      }
    },
    technicalValues: {
      impactSoundLevel: {
        // L,nw
        output: '55 (2; 3)',
        value: 55
      },
      soundReductionIndex: {
        // Rw
        output: '67 (-4; -11)',
        value: 67
      },
      heatTransferCoefficient: {
        // U-Wert
        output: '0,16',
        value: 0.16
      },
      fireResistance: {
        output: '-',
        value: null
      },
      massPerUnitArea: {
        output: '234,4 [kg/m²]'
      }
    }
  },
  image: 'da-hms-002.png',
  pdf: 'Holzbalkendecke-mit-Schalldämmplatten-Aufbau-2-DA-HMS-002-Rev01.pdf'
}
